var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCompass = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 66,
  height: 66,
  viewBox: "0 0 66 66",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M33 65C50.6731 65 65 50.6731 65 33C65 15.3269 50.6731 1 33 1C15.3269 1 1 15.3269 1 33C1 50.6731 15.3269 65 33 65Z",
  stroke: "#BDCAD1",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M26.7746 26.7746L19.0364 46.9636L39.2255 39.2255L46.9636 19.0364L26.7746 26.7746ZM33 35.6182C31.5455 35.6182 30.3818 34.4546 30.3818 33C30.3818 31.5455 31.5455 30.3818 33 30.3818C34.4546 30.3818 35.6182 31.5455 35.6182 33C35.6182 34.4546 34.4546 35.6182 33 35.6182Z",
  fill: "#845EC2"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCompass);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/compass.cec96ad40c48a9dd29f1cc9341826080.svg";